import { RouteType } from "types/RouteType";
import type RootStore from "stores/RootStore";
import {
  createMockStructureCastClientStore,
  createMockStructureCastProjectStore,
  createMockStructureCastStructureStore,
} from "serviceStores/mock";
import type StructureCastJobsClientsStore from "./MillerJobsClientsStore";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyRootStore = any;

const structureCastJobsClientsRoute: RouteType = {
  name: "Projects & Clients",
  path: "/structurecast-jobs-clients",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Projects & Clients",
      enableRefreshButton: true,
      enableBackButton: true,
      component: () => import("./MillerJobsClients.Header"),
    },
    body: {
      component: () => import("./MillerJobsClients.Body"),
      grayBackground: true,
    },
  },
  group: "Scheduling",
  requiresAuth: true,
  requiresPermission: false,
  dialogs: [
    {
      name: "clientForm",
      title: "Client",
      component: () => import("./dialogs/ClientFormDialog"),
      height: 650,
    },
    {
      name: "projectForm",
      title: "Project",
      component: () => import("./dialogs/JobFormDialog"),
      height: 700,
    },
  ],
  onEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    const rs = rootStore as AnyRootStore;

    // Initialize mock stores if not already present
    if (!rs.structureCastClientsStore) {
      rs.structureCastClientsStore = createMockStructureCastClientStore();
    }
    if (!rs.structureCastProjectsStore) {
      rs.structureCastProjectsStore = createMockStructureCastProjectStore();
    }
    if (!rs.structureCastStructuresStore) {
      rs.structureCastStructuresStore = createMockStructureCastStructureStore();
    }

    // Load data
    const store = rs.millerJobsClientsStore as StructureCastJobsClientsStore;
    if (store) {
      await store.loadData();
    }
  },
};

export default structureCastJobsClientsRoute;
